var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.rightLoading),expression:"rightLoading"}]},[_c('TabButton',{attrs:{"cityName":_vm.cityName,"level":_vm.level},on:{"emptyEcharts":_vm.emptyEcharts,"changeDateType":_vm.changeDateType}}),_c('div',{staticClass:"echartsHistogram",attrs:{"id":_vm.echartsHistogramId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }